<template>
  <div class="d-flex align-top flex-wrap pa-0 ma-0">
    <!-- If there are cart items, so no error -->
    <div v-if="item.storeCart.cart.length > 0" class="pt-4 pl-4">
      <div
        class="
          subtitle-1
          font-weight-regular
          px-4
          py-2
          mb-2
          white--text
          primary
        "
      >
        {{ $t("userOrdersPackagesList") }}
      </div>
      <!-- IZRAČUN MODULA ZA RAZVIJANJE SLIK -->
      <div
        v-if="
          item.storeCart.cart.filter((x) => x.module == G_MODULE_PHOTO_ORDER)
            .length > 0
        "
      >
        <div
          class="
            subtitle-1
            font-weight-regular
            px-3
            py-1
            my-2
            white--text
            secondary
          "
        >
          {{ getModuleName(G_MODULE_PHOTO_ORDER) }}
        </div>
        <div
          v-for="cartItem in item.storeCart.cart.filter(
            (x) => x.module == G_MODULE_PHOTO_ORDER
          )"
          :key="cartItem.id"
          class="ml-2"
        >
          <div class="mb-2">
            <v-btn
              v-show="mode == 'packages'"
              class="mr-1"
              fab
              text
              x-small
              outlined
              color="secondary"
              @click.stop
              :href="cartItem.url"
            >
              <v-icon>mdi-folder-download</v-icon>
            </v-btn>
            {{ getModuleName(cartItem.module) }} ({{ cartItem.totalCopies }})
            <v-btn
              v-if="cartItem.hasOwnProperty('done') && mode == 'packages'"
              fab
              text
              x-small
              :color="cartItem.done ? 'success' : 'gray'"
              @click.stop
              @click="setItemDone({ item: item, cid: cartItem.cartId })"
            >
              <v-icon v-if="cartItem.done">mdi-check-all</v-icon>
              <v-icon v-else>mdi-check</v-icon>
            </v-btn>
          </div>
          <div
            v-for="cartItemData in cartItem.imageDataStr"
            :key="cartItemData.str"
          >
            <div class="overline mb-1">
              {{ cartItemData.str }}
            </div>
          </div>
        </div>
        <!-- povzetek cen razvijanja fotografij -->
        <div class="subtitle-2 mx-1 mt-2 mb-1">
          {{ $t("userOrdersModPhotoOrderSummary") }} ({{
            item.storeCart.modPhotoOrderSummary.totalCopies
          }})
        </div>
        <div class="mx-2">
          {{ $t("userNewOrderSummary2Title") }}:
          {{ price(item.storeCart.modPhotoOrderSummary.totalSumLabPrice) }}
        </div>
        <div
          v-if="
            item.storeCart.modPhotoOrderSummary.totalSumQuantityDiscountPrice >
            0
          "
          class="mx-2"
        >
          <div>
            {{ $t("userNewOrderSummary3Title") }}:
            {{
              price(
                item.storeCart.modPhotoOrderSummary
                  .totalSumQuantityDiscountPrice
              )
            }}
            (-{{
              percent(
                item.storeCart.modPhotoOrderSummary.totalSumQuantityDiscount
              )
            }})
          </div>
          <div>
            {{ $t("userNewOrderSummary4Title") }}:
            {{
              price(item.storeCart.modPhotoOrderSummary.totalSumQuantityPrice)
            }}
          </div>
        </div>
        <!-- morebitni extraCharge -->
        <div
          v-if="
            item.storeCart.modPhotoOrderSummary.totalSumExtraCharge >
            item.storeCart.modPhotoOrderSummary.totalSumQuantityPrice
          "
          class="mx-2"
        >
          <div>
            {{ item.modulePhotoOrderExtraChargeMessage }}:
            {{ price(item.modulePhotoOrderExtraCharge) }}
          </div>
          <div>
            {{ $t("userNewOrderSummaryExtraChargeTitle") }}:
            {{ price(item.storeCart.modPhotoOrderSummary.totalSumExtraCharge) }}
          </div>
        </div>
        <!-- aktivna promo koda -->
        <div
          v-if="
            item.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscount > 0
          "
          class="mx-2"
        >
          <div>
            {{ $t("userNewOrderSummary5Title") }}:
            {{
              price(
                item.storeCart.modPhotoOrderSummary.totalSumPromoCodeDiscount
              )
            }}
            (-<span
              v-if="item.storeCart.activePromoCodeDiscountType == 'Pct'"
              >{{ percent(item.storeCart.activePromoCodeDiscount) }}</span
            ><span
              v-else-if="item.storeCart.activePromoCodeDiscountType == 'Amt'"
              >{{ price(item.storeCart.activePromoCodeDiscount) }}</span
            >)
          </div>
          <div>
            {{ $t("userNewOrderSummary5cTitle") }}:
            {{
              price(
                item.storeCart.modPhotoOrderSummary
                  .totalSumPromoCodeDiscountPrice
              )
            }}
          </div>
        </div>
      </div>
      <!-- IZRAČUN MODULA ZA FOTO IZDELKE -->
      <div
        v-if="
          item.storeCart.cart.filter((x) => x.module == G_MODULE_PHOTO_GIFT)
            .length > 0
        "
      >
        <div
          class="
            subtitle-1
            font-weight-regular
            px-3
            py-1
            my-2
            white--text
            secondary
          "
        >
          {{ getModuleName(G_MODULE_PHOTO_GIFT) }}
        </div>
        <div
          v-for="cartItem in item.storeCart.cart.filter(
            (x) => x.module == G_MODULE_PHOTO_GIFT
          )"
          :key="cartItem.id"
          class="ml-2"
        >
          <div class="mb-2">
            <v-btn
              v-show="mode == 'packages'"
              class="mr-1"
              fab
              text
              x-small
              outlined
              color="secondary"
              @click.stop
              :href="cartItem.url"
            >
              <span v-if="cartItem.superType !== undefined">
                <v-icon v-if="cartItem.superType == 0"
                  >mdi-package-variant</v-icon
                >
                <v-icon v-else-if="cartItem.superType == 1"
                  >mdi-glass-mug</v-icon
                >
                <v-icon v-else-if="cartItem.superType == 2">mdi-collage</v-icon>
                <v-icon v-else-if="cartItem.superType == 3"
                  >mdi-picture-in-picture-bottom-right</v-icon
                >
                <v-icon v-else-if="cartItem.superType == 4"
                  >mdi-wallet-giftcard</v-icon
                >
                <v-icon v-else-if="cartItem.superType == 5">mdi-resize</v-icon>
                <v-icon v-else-if="cartItem.superType == 6">mdi-palette</v-icon>
              </span>
              <span v-else>
                <v-icon>mdi-glass-mug</v-icon>
              </span>
            </v-btn>
            {{ cartItem.itemName }} ({{ cartItem.itemCopies }})
            <v-btn
              v-show="cartItem.hasOwnProperty('done') && mode == 'packages'"
              fab
              text
              x-small
              :color="cartItem.done ? 'success' : 'gray'"
              @click.stop
              @click="setItemDone({ item: item, cid: cartItem.cartId })"
            >
              <v-icon v-if="cartItem.done">mdi-check-all</v-icon>
              <v-icon v-else>mdi-check</v-icon>
            </v-btn>
          </div>
          <div class="overline mb-1">
            {{ cartItem.imageDataStr }}
          </div>
        </div>
        <!-- povzetek cen -->
        <div class="subtitle-2 mx-1 mt-2 mb-1">
          {{ $t("userOrdersModPhotoGiftSummary") }} ({{
            item.storeCart.modPhotoGiftSummary.totalCopies
          }})
        </div>
        <div class="mx-2">
          {{ $t("userNewOrderSummary2Title") }}:
          {{ price(item.storeCart.modPhotoGiftSummary.totalSumLabPrice) }}
        </div>
        <!-- morebitni extraCharge -->
        <div
          v-if="
            item.storeCart.modPhotoGiftSummary.totalSumExtraCharge >
            item.storeCart.modPhotoGiftSummary.totalSumLabPrice
          "
          class="mx-2"
        >
          <div>
            {{ item.modulePhotoGiftExtraChargeMessage }}:
            {{ price(item.modulePhotoGiftExtraCharge) }}
          </div>
          <div>
            {{ $t("userNewOrderSummaryExtraChargeTitle") }}:
            {{ price(item.storeCart.modPhotoGiftSummary.totalSumExtraCharge) }}
          </div>
        </div>
        <!-- aktivna promo koda -->
        <div
          v-if="
            item.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount > 0
          "
          class="mx-2"
        >
          <div>
            {{ $t("userNewOrderSummary5Title") }}:
            {{
              price(
                item.storeCart.modPhotoGiftSummary.totalSumPromoCodeDiscount
              )
            }}
            <span
              v-if="$store.state.storeCart.activePromoCodeSuperCategory != ''"
              >/
              {{
                $store.state.storeCart.activePromoCodeSuperCategoryName
              }}</span
            >
            <span v-if="$store.state.storeCart.activePromoCodeCategory != ''">
              /
              {{ $store.state.storeCart.activePromoCodeCategoryName }}</span
            >
            <span v-if="$store.state.storeCart.activePromoCodeItem != ''"
              >/ {{ $store.state.storeCart.activePromoCodeItemName }}</span
            >
            <span v-if="$store.state.storeCart.activePromoCodeSubItem != ''">
              /
              {{ $store.state.storeCart.activePromoCodeSubItemName }}</span
            >
            (-<span
              v-if="item.storeCart.activePromoCodeDiscountType == 'Pct'"
              >{{ percent(item.storeCart.activePromoCodeDiscount) }}</span
            ><span
              v-else-if="item.storeCart.activePromoCodeDiscountType == 'Amt'"
              >{{ price(item.storeCart.activePromoCodeDiscount) }}</span
            >)
          </div>
          <div>
            {{ $t("userNewOrderSummary5cTitle") }}:
            {{
              price(
                item.storeCart.modPhotoGiftSummary
                  .totalSumPromoCodeDiscountPrice
              )
            }}
          </div>
        </div>
      </div>
      <v-divider
        v-if="
          item.storeCart.activePromoCodeActivated ||
          item.deliveryExtraChargeInfo > 0
        "
        class="mb-1 mt-2"
      ></v-divider>
      <!-- PROMO KODA -->
      <div v-if="item.storeCart.activePromoCodeActivated" class="mx-2">
        <div>
          {{ $t("userNewOrderSummary5aTitle") }}:
          <strong>
            {{ item.storeCart.activePromoCode.toUpperCase() }}
          </strong>
          /
          {{ getModuleName(item.storeCart.activePromoCodeModule) }}
          <span v-if="$store.state.storeCart.activePromoCodeSuperCategory != ''"
            >/
            {{ $store.state.storeCart.activePromoCodeSuperCategoryName }}</span
          >
          <span v-if="$store.state.storeCart.activePromoCodeCategory != ''">
            /
            {{ $store.state.storeCart.activePromoCodeCategoryName }}</span
          >
          <span v-if="$store.state.storeCart.activePromoCodeItem != ''"
            >/ {{ $store.state.storeCart.activePromoCodeItemName }}</span
          >
          <span v-if="$store.state.storeCart.activePromoCodeSubItem != ''">
            /
            {{ $store.state.storeCart.activePromoCodeSubItemName }}</span
          >
          (-<span v-if="item.storeCart.activePromoCodeDiscountType == 'Pct'">{{
            percent(item.storeCart.activePromoCodeDiscount)
          }}</span
          ><span
            v-else-if="item.storeCart.activePromoCodeDiscountType == 'Amt'"
            >{{ price(item.storeCart.activePromoCodeDiscount) }}</span
          >)
        </div>
        <div>
          {{ $t("userNewOrderSummary5dTitle") }}:
          {{ price(item.storeCart.totalSumPromoCodeDiscount) }}
        </div>
      </div>
      <!-- DODATNI STROŠKI -->
      <div v-if="item.deliveryExtraChargeInfo > 0">
        <v-divider class="my-1"></v-divider>
        <div class="mx-2">
          {{ $t("userNewOrderSummary6Title") }}:
          {{ price(item.storeCart.totalSumCart) }}
        </div>
        <div class="mx-2">
          {{ item.deliveryExtraChargeMessage }}:
          {{ price(item.deliveryExtraChargeInfo) }}
        </div>
      </div>
      <v-divider class="my-1"></v-divider>
      <div class="mx-2">
        <strong>
          {{ $t("userOrdersFullSummary") }}:
          {{ price(item.deliveryFinalSum) }}
        </strong>
      </div>
      <!--<div v-if="item.messageForStudio.length > 0" class="mx-2 mt-2">
        {{ $t("userOrdersMessageForStudio") }}:
        {{ item.messageForStudio }}
      </div>-->
    </div>
    <div v-else class="pt-4 pl-4">
      <div class="mx-2 mb-2">
        {{ $t("homeMenuAdminPackagesTemporaryPackages") }}
      </div>
      <div v-html="extractLinks(item.sendEmailHtml)" class="mx-2 mb-2"></div>
      <div class="mx-2">
        <strong>
          {{ $t("userOrdersFullSummary") }}:
          {{ price(item.deliveryFinalSum) }}
        </strong>
      </div>
    </div>

    <div class="pt-4 pl-4">
      <!-- OSTALI OSEBNI PODATKI -->
      <div
        class="
          subtitle-1
          font-weight-regular
          px-4
          py-2
          mb-2
          white--text
          primary
        "
      >
        {{ $t("userOrdersUserDataList") }}
      </div>
      <div>
        <div v-if="item.isCompany">
          <v-icon small class="mr-2">mdi-numeric</v-icon>
          {{ item.vatNumber }}
        </div>
        <div>
          <v-icon small class="mr-2">mdi-face</v-icon>
          {{ item.fullName }}
        </div>
        <div>
          <v-icon small class="mr-2">mdi-home</v-icon>
          {{ item.address1 }}
        </div>
        <div>
          <v-icon small class="mr-2">mdi-city</v-icon>
          {{ item.address2 }}
        </div>
        <div>
          <v-icon small class="mr-2">mdi-flag</v-icon>
          {{ item.country }}
        </div>
        <div>
          <v-icon small class="mr-2">mdi-cellphone</v-icon>
          {{ item.phone }}
        </div>
        <div>
          <v-icon small class="mr-2">mdi-at</v-icon>
          {{ item.email }}
        </div>
        <div v-if="stats && item.orders > 0">
          <v-icon small class="mr-2">mdi-sigma</v-icon>
          {{ item.orders }} / {{ Math.round(item.ordersSum) }}
          {{
            this.$store.state.storeClient.client.environmentSettings.currency
          }}
        </div>
      </div>
    </div>

    <div class="pt-4 pl-4">
      <!-- POGOVOR O NAROČILU -->
      <div
        class="
          subtitle-1
          font-weight-regular
          px-4
          py-2
          mb-2
          white--text
          primary
        "
      >
        <span class="mr-2">
          {{ $t("userOrdersMessages") }}
        </span>

        <!-- send extra email button -->
        <v-btn
          class="primary--text elevation-0"
          small
          @click="
            currentItem = item;
            dialogSendExtraEmail = true;
          "
        >
          <v-icon class="mr-1">mdi-email-send</v-icon
          >{{ $t("lmBtnNewMessage") }}
        </v-btn>
      </div>

      <!-- izpis sporočil o naročilu -->
      <div
        v-if="item.messageForStudio.length == 0"
        class="mt-2 px-2 py-1"
        style="max-width: 400px"
      >
        <v-icon small class="mr-1">mdi-message-reply-text</v-icon>
        {{ $t("homeMenuAdminPackagesNoMessages") }}
      </div>
      <div
        v-else-if="Array.isArray(item.messageForStudio)"
        class="mt-2 px-2 py-1"
        style="max-width: 400px"
      >
        <div
          v-for="(item2, index) in item.messageForStudio"
          :key="index"
          class="pb-1"
        >
          <div v-if="mode == 'user'">
            <div
              v-if="item2.mode != 'user'"
              style="max-width: 400px; background-color: red; color: white"
            >
              <div
                class="pt-1 px-2 ma-0"
                style="font-size: 11px; font-style: italic"
              >
                {{ item2.fullName }}
                <span v-if="item2.timestamp.seconds !== undefined">
                  / {{ getMoment(item2.timestamp.seconds) }}</span
                >
              </div>
              <div class="pb-1 px-2">
                <v-icon small dark class="mr-2">mdi-message-reply-text</v-icon
                >{{ item2.msg }}
              </div>
            </div>
            <div v-else style="max-width: 400px">
              <div
                class="pt-1 px-2 ma-0"
                style="font-size: 11px; font-style: italic"
              >
                {{ item2.fullName }}
                <span v-if="item2.timestamp.seconds !== undefined">
                  / {{ getMoment(item2.timestamp.seconds) }}</span
                >
              </div>
              <div class="pb-1 px-2">
                <v-icon small class="mr-2">mdi-message-reply-text</v-icon
                >{{ item2.msg }}
              </div>
            </div>
          </div>
          <div v-else>
            <div
              v-if="item2.mode == 'user'"
              class="pa-1 px-2"
              style="max-width: 400px; background-color: red; color: white"
            >
              <div
                class="pt-1 px-2 ma-0"
                style="font-size: 11px; font-style: italic"
              >
                {{ item2.fullName }}
                <span v-if="item2.timestamp.seconds !== undefined">
                  / {{ getMoment(item2.timestamp.seconds) }}</span
                >
              </div>
              <div class="pb-1 px-2">
                <v-icon small dark class="mr-2">mdi-message-reply-text</v-icon
                >{{ item2.msg }}
              </div>
            </div>
            <div v-else class="pa-1 px-2" style="max-width: 400px">
              <div
                class="pt-1 px-2 ma-0"
                style="font-size: 11px; font-style: italic"
              >
                {{ item2.fullName }}
                <span v-if="item2.timestamp.seconds !== undefined">
                  / {{ getMoment(item2.timestamp.seconds) }}</span
                >
              </div>
              <div class="pb-1 px-2">
                <v-icon small class="mr-2">mdi-message-reply-text</v-icon
                >{{ item2.msg }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-if="mode == 'user'" class="pa-1 px-2" style="max-width: 400px">
          <v-icon small class="mr-1">mdi-message-reply-text</v-icon>
          {{ item.messageForStudio }}
        </div>
        <div
          v-else
          class="pa-1 px-2"
          style="max-width: 400px; background-color: red; color: white"
        >
          <v-icon small dark class="mr-1">mdi-message-reply-text</v-icon>
          {{ item.messageForStudio }}
        </div>
      </div>
    </div>

    <div class="pt-4 pl-4">
      <!-- POVEZANI Z NAROČILOM -->
      <div
        class="
          subtitle-1
          font-weight-regular
          px-4
          py-2
          mb-2
          white--text
          secondary
        "
      >
        {{ $t("userOrdersAdminWorkList") }}
      </div>

      <div>
        <div v-if="item.status0SetBy !== undefined">
          <div v-if="item.status0SetBy.length > 0">
            <v-icon color="error" small class="mr-1">mdi-circle-slice-8</v-icon>
            {{ item.status0SetBy }} ({{
              getMoment(item.status0Timestamp.seconds)
            }})
          </div>
        </div>
        <div v-if="item.status1SetBy !== undefined">
          <div v-if="item.status1SetBy.length > 0">
            <v-icon color="warning" small class="mr-1"
              >mdi-circle-slice-8</v-icon
            >
            {{ item.status1SetBy }} ({{
              getMoment(item.status1Timestamp.seconds)
            }})
          </div>
        </div>
        <div v-if="item.status2SetBy !== undefined">
          <div v-if="item.status2SetBy.length > 0">
            <v-icon color="success" small class="mr-1"
              >mdi-circle-slice-8</v-icon
            >
            {{ item.status2SetBy }} ({{
              getMoment(item.status2Timestamp.seconds)
            }})
          </div>
        </div>
        <div v-if="item.status3SetBy !== undefined">
          <div v-if="item.status3SetBy.length > 0">
            <v-icon color="black" small class="mr-1">mdi-circle-slice-8</v-icon>
            {{ item.status3SetBy }} ({{
              getMoment(item.status3Timestamp.seconds)
            }})
          </div>
        </div>
      </div>
    </div>

    <!-- send email and add message to customer dialog -->
    <dialog-send-msg
      :active="dialogSendExtraEmail"
      @clickAdd="sendEmailMsg"
      @clickCancel="dialogSendExtraEmail = false"
      icon="mdi-email-send"
      :title="$t('homeMenuAdminPackagesSendExtraEmail')"
      addBtnIcon="mdi-email-send-outline"
      :addBtnText="$t('lmBtnSend')"
      >{{ $t("homeMenuAdminPackagesSendExtraEmailRecipient") }}:
      {{ currentItem.email }} ({{ currentItem.orderId }})</dialog-send-msg
    >
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/functions";
import moment from "moment";
import {
  G_MODULE_PHOTO_ORDER,
  G_MODULE_PHOTO_GIFT,
  G_MODULE_ALL,
} from "@/constants";
import DialogSendMsg from "@/components/DialogSendMsg";

export default {
  name: "display-order-info",
  components: {
    DialogSendMsg,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: false,
    },
    stats: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      dialogSendExtraEmail: false,
      currentItem: {},
      extraEmailMsg: "",
      currentItemUpdatedMsg: [],
    };
  },
  methods: {
    extractLinks(html) {
      let doc = document.createElement("temp_html");
      doc.innerHTML = html;
      let links = doc.getElementsByTagName("a");
      let links_str = "";

      for (let i = 0; i < links.length; i++) {
        links_str +=
          "<a href='" + links[i].getAttribute("href") + "'>[DL]</a>&nbsp;";
      }

      return links_str;
    },
    sendEmailMsg(msg) {
      return new Promise((resolve, reject) => {
        this.dialogSendExtraEmail = false;

        let msgObj = {
          client: this.$store.state.storeClient.client.basicSettings.name,
          recipientEmail: this.currentItem.email,
          senderFullName:
            this.$store.state.storeClient.client.basicSettings.fullName,
          senderEmail:
            this.$store.state.storeClient.client.environmentSettings
              .autoResponseEmail,
          senderSubject:
            this.$store.state.storeClient.client.basicSettings.fullName +
            " | " +
            this.$t("homeMenuAdminPackagesSendExtraEmailStudio") +
            " " +
            this.currentItem.orderId,
          senderBody:
            "<p style='padding: 5px 10px 5px 10px; background-color: #ffcccc" +
            "; color: black;'>" +
            msg +
            "</p>" +
            "<p style='padding: 5px 10px 5px 10px;" +
            "; color: silver;'>" +
            this.$t("homeMenuAdminPackagesSendExtraEmailMsg1") +
            "</p>",
        };

        //console.log(msgObj);

        let sendFunctionEmailMsg = firebase
          .functions()
          .httpsCallable("sendRealEmailMsg");
        sendFunctionEmailMsg(msgObj)
          .then(async (res) => {
            console.log(res);
            if (res.data == "OK") {
              // generiranje novega sporočila v bazo je odvisno ali je notri že kakšno sporočilo ali ne
              if (this.currentItem.messageForStudio.length <= 0) {
                this.currentItemUpdatedMsg.push({
                  mode: this.mode,
                  timestamp: new Date(),
                  fullName: this.$store.state.storeAuth.userProfile.fullName,
                  msg: msg,
                });
              } else if (Array.isArray(this.currentItem.messageForStudio)) {
                this.currentItemUpdatedMsg = this.currentItem.messageForStudio;
                this.currentItemUpdatedMsg.push({
                  mode: this.mode,
                  timestamp: new Date(),
                  fullName: this.$store.state.storeAuth.userProfile.fullName,
                  msg: msg,
                });
              } else {
                this.currentItemUpdatedMsg.push({
                  mode: this.mode,
                  timestamp: 0,
                  fullName: "",
                  msg: this.currentItem.messageForStudio,
                });
                this.currentItemUpdatedMsg.push({
                  mode: this.mode,
                  timestamp: new Date(),
                  fullName: this.$store.state.storeAuth.userProfile.fullName,
                  msg: msg,
                });
              }

              // zapis v bazo
              this.currentItem.messageForStudio = this.currentItemUpdatedMsg;
              await this.$store.dispatch("setOrderPackages", this.currentItem);

              this.$store.commit({
                type: "showSnackbar",
                color: "success",
                message: this.$t("homeMenuCartInfoSendEmailSuccessTitle"),
              });
            } else {
              this.$store.commit({
                type: "showSnackbar",
                color: "error",
                message: this.$t("homeMenuCartInfoSendEmailErrorTitle"),
              });
            }
            resolve();
          })
          .catch((error) => {
            console.log(error);
            reject();
          });
      });
    },
    getMoment(item) {
      return moment.unix(item).format("DD.MM.YY HH:mm");
    },
    async toggleGiftBooleanActive(item, field) {
      try {
        await this.$store.dispatch(field, item);
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    async setItemDone(payload) {
      try {
        await this.$store.dispatch("toggleOrderCartItemDone", payload);
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
  },
  created() {
    this.G_MODULE_PHOTO_ORDER = G_MODULE_PHOTO_ORDER;
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;
    this.G_MODULE_ALL = G_MODULE_ALL;
  },
};
</script>

<style scoped>
</style>